import { render } from "./HeroiconsOutlineShoppingCart.vue?vue&type=template&id=3412f4a5"
const script = {}

import exportComponent from "/home/roland/vscode/yachtbroker/portal/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineShoppingCart.vue"]])

export default __exports__